import { consents } from './consents';
import { travelers } from './travelers';
import { setupTravelInsurant } from './setupTravelInsurant';
import { insurant } from './insurant';
import { obfuscation } from './obfuscation';

export const travelCheckout = {
  ...consents,
  ...insurant,
  ...travelers,
  ...setupTravelInsurant,
  ...obfuscation,
};
